import React from 'react';
import { Star } from 'lucide-react';
export function StatsBar() {
  return <div className="bg-charcoal text-white py-8 border-b-4 border-gold" data-id="element-344">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-345">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-white/10" data-id="element-346">
          <div className="flex flex-col items-center justify-center" data-id="element-347">
            <span className="text-3xl md:text-4xl font-serif font-bold text-gold mb-1" data-id="element-348">
              +1.200
            </span>
            <span className="text-sm text-gray-300 uppercase tracking-wider" data-id="element-349">
              propietarios confían
            </span>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-350">
            <span className="text-3xl md:text-4xl font-serif font-bold text-gold mb-1" data-id="element-351">
              6
            </span>
            <span className="text-sm text-gray-300 uppercase tracking-wider" data-id="element-352">
              Tomos listos
            </span>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-353">
            <span className="text-3xl md:text-4xl font-serif font-bold text-gold mb-1" data-id="element-354">
              4
            </span>
            <span className="text-sm text-gray-300 uppercase tracking-wider" data-id="element-355">
              Bonos incluidos
            </span>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-356">
            <span className="text-3xl md:text-4xl font-serif font-bold text-gold mb-1 flex items-center gap-2" data-id="element-357">
              4.9/5
            </span>
            <div className="flex text-gold mb-1" data-id="element-358">
              <Star className="w-4 h-4 fill-current" data-id="element-359" />
              <Star className="w-4 h-4 fill-current" data-id="element-360" />
              <Star className="w-4 h-4 fill-current" data-id="element-361" />
              <Star className="w-4 h-4 fill-current" data-id="element-362" />
              <Star className="w-4 h-4 fill-current" data-id="element-363" />
            </div>
            <span className="text-sm text-gray-300 uppercase tracking-wider" data-id="element-364">
              calificación
            </span>
          </div>
        </div>
      </div>
    </div>;
}